module.exports = __webpack_public_path__ + "static/img/iosDownload.f9f59f7e.png";